export const status =[
                    { value: "1", label: "Created" , icon:<span className="blue me-2"></span>},
                    // { value: "2", label: "Converted",icon:<span className="green me-2"></span> },
                    { value: "3", label: "In Progress",icon:<span className="orange me-2"></span> },
                    { value: "4", label: "Not Intrested",icon:<span className="pink me-2"></span> },
                    { value: "5", label: "Not Answered",icon:<span className="dark me-2"></span> },
                  ];
                  export const statusone =[
                    { value: "1", label: "Created" , icon:<span className="blue me-2"></span>},
                    // { value: "2", label: "Converted",icon:<span className="green me-2"></span> },
                    { value: "3", label: "In Progress",icon:<span className="orange me-2"></span> },
                    { value: "4", label: "Not Intrested",icon:<span className="pink me-2"></span> },
                    { value: "5", label: "Not Answered",icon:<span className="dark me-2"></span> },
                  ];
                  
                export  const ReminderTo = [
                    { value: "1", label: "Customer & CS Executive" },
                    { value: "2", label: "Converted" },
                    { value: "3", label: "In Progress" },
                    { value: "4", label: "Not Intrested" },
                    { value: "5", label: "Not Answered" },
                  ];
                  export const Reminderfor = [
                    { value: "1", label: "Clinical Visit" },
                    { value: "2", label: "Converted" },
                    { value: "3", label: "In Progress" },
                    { value: "4", label: "Not Intrested" },
                    { value: "5", label: "Not Answered" },
                  ];
                  export const ReminderOncein = [
                    { value: "1", label: "1 Day" },
                    { value: "2", label: "2 Days" },
                    { value: "3", label: "3 Days" },
                    { value: "4", label: "5 Days" },
                    { value: "5", label: "6 Days" },
                  ];
                  export const Mediums = [
                    { value: "WP", label: "whatsapp",icon:<img src={require(`../../../../assets/DigitalMarketing/image/customer/reminder/WP.png`)} className="reminder-img"/>},
                    // { value: "PC", label: "Phone Call",icon:<img src={require(`../../../../assets/DigitalMarketing/image/customer/reminder/PC.png`)} className="reminder-img"/> },
                    // { value: "SMS", label: "SMS",icon:<img src={require(`../../../../assets/DigitalMarketing/image/customer/reminder/SMS.png`)} className="reminder-img"/> },
                    // { value: "EM", label: "Email",icon:<img src={require(`../../../../assets/DigitalMarketing/image/customer/reminder/EM.png`)} className="reminder-img"/> },
                  ];
                  export const CallStatus = [
                    { value: "1", label: "Answered"},
                    { value: "2", label: "Sent" },
                    { value: "3", label: "Seen"},
                    { value: "4", label: "Not Available"},
                  ];
                  export const Sourceoption = [
                    { value: "Whatsapp", label: "Whatsapp"},
                    { value: "Facebook", label: "Facebook" },
                    { value: "Instagram", label: "Instagram"},
                    { value: "Twitter", label: "Twitter"},
                  ];
                  export const LogMediums = [
                    { value: "1", label: "whatsapp",icon:<img src={require(`../../../../assets/DigitalMarketing/image/customer/reminder/WP.png`)} className="reminder-img"/>},
                    { value: "2", label: "Phone Call",icon:<img src={require(`../../../../assets/DigitalMarketing/image/customer/reminder/PC.png`)} className="reminder-img"/> },
                    { value: "3", label: "SMS",icon:<img src={require(`../../../../assets/DigitalMarketing/image/customer/reminder/SMS.png`)} className="reminder-img"/> },
                    { value: "4", label: "Email",icon:<img src={require(`../../../../assets/DigitalMarketing/image/customer/reminder/EM.png`)} className="reminder-img"/> },
                    // { value: "5", label: "Dashboard",icon:<img src={require(`../../../../assets/DigitalMarketing/image/customer/reminder/DASHBOARD.png`)} className="reminder-img"/>},
                  ];